import ApiService from '@/services/core/api.service'

const BusinessPartnerDraftService = {
  async get (query = '') {
    return ApiService.get(`tax-accountant/business-partner-drafts?${query}`)
  },

  async post (payload) {
    return ApiService.post('tax-accountant/business-partner-drafts', payload)
  },

  async put (payload) {
    return ApiService.put(`tax-accountant/business-partner-drafts/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`tax-accountant/business-partner-drafts/${payload.id}`)
  }
}

export default BusinessPartnerDraftService
